export enum BENEFITS_TEST_IDS {
  DETAILS_CONTAINER = 'benefits_test_details_container',
}
